module.exports = __webpack_public_path__ + "img/galery-dcu30-1-zoom.32d33aa1.png";